import(/* webpackMode: "eager" */ "/app/node_modules/@akinon/next/utils/get-currency.ts");
;
import(/* webpackMode: "eager", webpackExports: ["GlobalDataLayer"] */ "/app/src/components/global-datalayer.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/views/breadcrumb.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/views/category/category-info.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["CategorySeo"] */ "/app/src/views/category/category-seo.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["SearchNotFound"] */ "/app/src/views/category/not-found.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/views/widgets/special-page-seller-panel/index.tsx");
